<template>
  <van-nav-bar
    :fixed="true"
    left-arrow
    left-text="返回"
    :title="title"
    @click-left="onClickLeft"
    @click-right="onClickRight"
  >
    <template #left>
      <slot name="left">
        <van-icon name="arrow-left" size="24" />
      </slot>
    </template>
    <template #right>
      <slot name="right">
        <!-- <van-icon name="wap-home-o" size="24" /> -->
      </slot>
    </template>
  </van-nav-bar>
</template>
<script>
  import { useRouter } from 'vue-router'
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    setup() {
      const router = useRouter()
      const onClickLeft = () => {
        router.back()
      }
      const onClickRight = () => {
        router.replace({
          name: 'Home',
        })
      }
      return {
        onClickLeft,
        onClickRight,
      }
    },
  }
</script>
